import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['countryLink', 'selectedCountry', 'locationButton', 'languageLink', 'selectedLanguage']

  connect () {
    this.countryLinks = this.countryLinkTargets
    this.selectedCountry = this.selectedCountryTarget

    this.languageLinks = this.hasLanguageLinkTarget ? this.languageLinkTargets : []
    this.selectedLanguage = this.hasSelectedLanguageTarget ? this.selectedLanguageTarget : null

    this.locationButton = this.locationButtonTarget

    this.countryLinks.forEach((link) => {
      if (this.selectedCountry.dataset.locale === link.dataset.locale) {
        this.locationButton.setAttribute('data-href', link.href)
      }
      link.addEventListener('click', this.selectCountry.bind(this))
    })

    this.languageLinks.forEach((link) => {
      if (this.selectedLanguage.dataset.language === link.dataset.language) {
        this.locationButton.setAttribute('data-href', link.href)
        this.locationButton.setAttribute('data-language', link.dataset.language)
      }
      link.addEventListener('click', this.selectLanguage.bind(this))
    })

    this.locationButton.addEventListener(
      'click',
      this.redirectToCountry.bind(this)
    )
  }

  selectCountry (event) {
    event.preventDefault()

    this.countryLinks.forEach((link) => {
      Array.from(link.children).forEach((child) => {
        child.classList.remove('fw-semibold')
      })
    })

    const clickedLink = event.currentTarget
    const clickedChild = clickedLink.children[1]
    clickedChild.classList.add('fw-semibold')

    const newLocaleText = clickedLink.textContent.trim()
    const newHref = clickedLink.href

    this.selectedCountry.textContent = newLocaleText
    this.locationButton.setAttribute('data-href', newHref)
  }

  selectLanguage (event) {
    event.preventDefault()

    this.languageLinks.forEach((link) => {
      Array.from(link.children).forEach((child) => {
        child.classList.remove('fw-semibold')
      })
    })

    const clickedLink = event.currentTarget
    const clickedChild = clickedLink.children[0]
    clickedChild.classList.add('fw-semibold')

    const newLocaleText = clickedLink.textContent.trim()
    const language = clickedLink.dataset.language

    this.selectedLanguage.textContent = newLocaleText
    this.locationButton.setAttribute('data-href', clickedLink.href)
    this.locationButton.setAttribute('data-language', language)
  }

  redirectToCountry () {
    const redirectUrl = this.locationButton.getAttribute('data-href')
    const language = this.locationButton.getAttribute('data-language')
    if (redirectUrl) {
      const url = new URL(redirectUrl, window.location.origin)
      if (language) {
        const segments = url.pathname.split('/').filter(Boolean)
        if (segments.length >= 2) {
          segments[0] = language
          url.pathname = `/${segments.join('/')}`
        }
      }
      window.location.href = url.toString()
    }
  }
}
